/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Systemsettings_Themelightdescription3Inputs */

const zh_systemsettings_themelightdescription3 = /** @type {(inputs: Systemsettings_Themelightdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`始终使用浅色主题。`)
};

const en_systemsettings_themelightdescription3 = /** @type {(inputs: Systemsettings_Themelightdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Always use the light theme.`)
};

const es_systemsettings_themelightdescription3 = /** @type {(inputs: Systemsettings_Themelightdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usar siempre el tema claro.`)
};

/**
* | output |
* | --- |
* | "Always use the light theme." |
*
* @param {Systemsettings_Themelightdescription3Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const systemsettings_themelightdescription3 = /** @type {((inputs?: Systemsettings_Themelightdescription3Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Systemsettings_Themelightdescription3Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_systemsettings_themelightdescription3(inputs)
	if (locale === "en") return en_systemsettings_themelightdescription3(inputs)
	return es_systemsettings_themelightdescription3(inputs)
});
export { systemsettings_themelightdescription3 as "systemSettings_themeLightDescription" }